export const registerReducerKey = 'registerReducerKey';
export const registerSetIpAddressReducerType = 'registerSetIpAddressReducerType';
export const registerSetIsLoadingReducerType = 'registerSetIsLoadingReducerType';
export const registerSetDataReducerType = 'registerSetDataReducerType';
export const registerSetRegisterFailReducerType = 'registerSetRegisterFailReducerType';
export const typeOfRegisterModal = 'typeOfRegisterModal';
